<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div class="eventDiv eventBox" @click="goToEvent()" ref="eventBox">
    <h3 class="eventHeaderN">{{ title }}</h3>
    <p class="eventBodyN event-date">{{ eventDate }}</p>
    <p v-if="!isEmpty(eventTime)" class="eventBodyN event-time">{{ eventTime }}</p>
    <div class="location-wrapper">
      <img src="@/assets/index/location_details_solid.svg" class="eventLocIcon" alt=""/><p class="eventLoc blueLink">{{ loc }}</p>
    </div>
    <p class="eventCategory">{{ allCategories }}</p>
    <font-awesome-icon style="color:var(--uog-dark-blue);" icon="arrow-right" size="sm" class="eventChev"></font-awesome-icon>
  </div>
</template>

<script setup>
//Utilities
import { ref, computed, defineExpose } from 'vue'
import { store } from '@/components/reactiveStore.js'
import { useRouter } from 'vue-router'
const router = useRouter()

//Composables
import { useStringUtil }  from '@/composables/StringMethods.js'
const { displayEventInfo, isEmpty } = useStringUtil();

const props = defineProps({
  title: String,
  body: Object,
  startDate: Number,
  endDate: Number,
  startTime: String,
  endTime: String,
  loc: String,
  event: Object
})

//Data
let evinfo = displayEventInfo(props.startDate, props.endDate, props.startTime, props.endTime)

const eventDate = ref(evinfo.date)
const eventTime = ref(evinfo.time)
const eventBox = ref(null)
    

//Computed
const allCategories = computed(() => {
  const cats = props.event.categories
  return cats.map((c) => { return c.name }).join(', ')
})

//Expose the ref eventBox so parent Events.vue can access the html element for scrolling to
defineExpose({
  eventBox
})

function goToEvent () {
  /*
    props: [
    'title', 'body', 'startDate', 
    'endDate', 'startTime', 'endTime', 
    'loc', 'event'],
  */
  store.put({
    event: props.event
  })
  router.push({
  //  name: 'singleClub', params: { 'club': this.club } }
    name: 'singleEvent'
  })
}

function prettyDate (date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
  var dateReady = new Date(date)
  return dateReady.toLocaleDateString('en-GB', options)
}

function checkMultiDate () {
  // var start = new Date(startDate)
  // var end = new Date(endDate)
  // if (start == end) return false
  // return true
  return false // until we get event end dates
}

</script>

<style scoped>
.eventBox {
  border: 1px solid #ccc;
  border-bottom: none;
  border-left: none;
  border-right: none;
  padding: 1rem;
  padding-right: 2rem;
  position: relative;
}

.eventBox:hover {
  cursor:pointer;
}

.events-listing-container .eventBox:first-child {
  border-top:none;
}

.eventHeaderN {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: var(--uog-dark-blue);
}

.eventBodyN {
  font-size: 16px;
  color: #1D1D1D;
  margin-bottom: 0px;
  display: block;
}

.event-time {
  margin-bottom:0.5rem;
}

.location-wrapper {
  display: flex;
  margin-bottom: 0.5rem;
}

.eventLocIcon {
  height: 18px;
  margin-right: 0.5rem;
}

.eventLoc {
  margin-bottom:0px;
}

.eventCategory {
  font-size: 14px;
  color: #666666;
  margin-bottom: 0px;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.eventSocial {
  display:inline-block;
  padding-bottom:20px;
}

.eventSocial img {
  margin-right:8px;
  margin-left:0px;
}

.eventChev {
  position:absolute;
  top:45%;
  right:16px;
}

.eventBg {
  position:absolute;
  left:10px;
  top:10px;
  z-index:-1;
}

</style>
